

import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  
  setup() {
    // console.log("node_env = " + process.env.NODE_ENV)
    console.log("language: " + navigator.language);
  },
  methods: {
   GoToKerryHub(): void
    {
      window.location.href = process.env.VUE_APP_KERRYHUB_URL
    },
    GotoEmployeePromptForm(): void
    {

      this.$router.push('EmployeePromptForm');
    }

  }

})


